import { render } from "./ProductMenu.vue?vue&type=template&id=12b6d16e"
import script from "./ProductMenu.vue?vue&type=script&lang=js"
export * from "./ProductMenu.vue?vue&type=script&lang=js"

import "./ProductMenu.vue?vue&type=style&index=0&id=12b6d16e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__